import React, { Component } from 'react';

let turnstileScriptLoading = false;
let turnstileScriptLoaded = false;
const readyCallbacks = [];

function loadTurnstileScript() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.turnstile) {
    turnstileScriptLoaded = true;
    return;
  }
  if (turnstileScriptLoading) return;
  turnstileScriptLoading = true;

  const script = document.createElement('script');
  script.id = 'cloudflare-turnstile-script';
  script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
  script.onload = () => {
    turnstileScriptLoaded = true;
    turnstileScriptLoading = false;
    while (readyCallbacks.length > 0) {
      const cb = readyCallbacks.shift();
      try { cb(); } catch (e) { console.error('Error en callback Turnstile:', e); }
    }
  };
  script.onerror = (err) => {
    turnstileScriptLoading = false;
    console.error('Error al cargar Cloudflare Turnstile script:', err);
  };
  document.head.appendChild(script);
}

function onTurnstileReady(cb) {
  if (typeof window !== 'undefined' && window.turnstile && typeof window.turnstile.render === 'function') {
    cb();
    return;
  }
  readyCallbacks.push(cb);
  loadTurnstileScript();
}

export default class Turnstile extends Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.widgetId = null;
    this.isMounted_ = false;
  }

  componentDidMount() {
    this.isMounted_ = true;
    loadTurnstileScript();
    this.renderWidget();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sitekey !== this.props.sitekey && this.props.sitekey) {
      this.resetWidget();
    }
  }

  componentWillUnmount() {
    this.isMounted_ = false;
    this.removeWidget();
  }

  renderWidget = () => {
    const { sitekey, size = 'invisible', onChange, onErrored, onExpired } = this.props;
    if (!sitekey) return;

    onTurnstileReady(() => {
      if (!this.isMounted_ || !this.containerRef.current) return;
      if (this.widgetId !== null) {
        this.removeWidget();
      }

      try {
        this.widgetId = window.turnstile.render(this.containerRef.current, {
          sitekey: sitekey,
          size: size === 'invisible' ? 'invisible' : (size || 'normal'),
          execution: size === 'invisible' ? 'execute' : 'render',
          callback: (token) => {
            if (this.isMounted_ && onChange) {
              onChange(token);
            }
          },
          'error-callback': (code) => {
            if (this.isMounted_ && onErrored) {
              onErrored(code);
            }
          },
          'expired-callback': () => {
            if (this.isMounted_ && onExpired) {
              onExpired();
            }
          },
          'timeout-callback': () => {
            if (this.isMounted_ && onExpired) {
              onExpired();
            }
          }
        });
      } catch (err) {
        console.error('Error al inicializar Cloudflare Turnstile widget:', err);
      }
    });
  };

  removeWidget = () => {
    if (typeof window !== 'undefined' && window.turnstile && this.widgetId !== null) {
      try {
        window.turnstile.remove(this.widgetId);
      } catch (e) {}
      this.widgetId = null;
    }
  };

  resetWidget = () => {
    this.removeWidget();
    this.renderWidget();
  };

  execute = () => {
    if (typeof window !== 'undefined' && window.turnstile && this.widgetId !== null) {
      try {
        window.turnstile.execute(this.widgetId);
      } catch (err) {
        console.error('Error al ejecutar Turnstile:', err);
      }
    } else {
      onTurnstileReady(() => {
        if (this.widgetId !== null) {
          try {
            window.turnstile.execute(this.widgetId);
          } catch (e) {}
        }
      });
    }
  };

  reset = () => {
    if (typeof window !== 'undefined' && window.turnstile && this.widgetId !== null) {
      try {
        window.turnstile.reset(this.widgetId);
      } catch (err) {
        console.error('Error al reiniciar Turnstile:', err);
      }
    }
  };

  render() {
    return <div ref={this.containerRef} className="cf-turnstile-wrapper" style={{ display: 'inline-block' }} />;
  }
}
